import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, tokenStore, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!tokenStore.get()) {
      setChecking(false);
      return;
    }
    api
      .get("/admin/me")
      .then(({ data }) => setAdmin(data))
      .catch(() => setAdmin(null))
      .finally(() => setChecking(false));
  }, []);

  const login = useCallback(async (username, password) => {
    try {
      const { data } = await api.post("/admin/login", { username, password });
      tokenStore.set(data.access_token);
      const me = await api.get("/admin/me");
      setAdmin(me.data);
      return { ok: true };
    } catch (e) {
      const message = formatApiErrorDetail(e?.response?.data?.detail) || e.message;
      return { ok: false, error: message };
    }
  }, []);

  const logout = useCallback(() => {
    tokenStore.clear();
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
